"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import {
  chatbot_user_email,
  code_sent_not_verified,
  isValidEmail,
} from "@/lib/lib";
import { REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
import { useCallback, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { toast } from "sonner";

interface EmailVerificationFlowProps {
  onVerified: (email: string) => void;
  // emailProp?: string | null;
  // setEmailProp?: (email: string) => void;
}

export function EmailVerificationFlow({
  onVerified,
}: EmailVerificationFlowProps) {
  const [step, setStep] = useState<"email" | "code" | undefined>("email");
  // const [emailState, setEmailState] = useState(emailProp || "");
  const [emailState, setEmailState] = useState("");
  const [codeBeenSent, setCodeBeenSent] = useState(false);
  const [code, setCode] = useState("");
  const [emailError, setEmailError] = useState("");
  const [codeError, setCodeError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [finishFirstStep, setFinishFirstStep] = useState(false);

  // Helper for API calls
  const callApi = async (
    endpoint: string,
    body: object,
    onSuccess: (data: any) => void,
    onError: (errorMsg: string) => void
  ) => {
    setIsLoading(true);
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (response.ok) {
        onSuccess(data);
      } else {
        onError(data.error || "An unexpected error occurred.");
      }
    } catch (error) {
      onError("A network error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   async function dd() {
  //     const stored = await verificationStore.get(email);
  //     if (stored) {
  //       setFinishFirstStep(true);
  //     }
  //   }
  //   dd();
  // }, []);

  const handleSendEmailCode = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setEmailError("");

      if (!isValidEmail(emailState)) {
        setEmailError("Please enter a valid address");
        toast.error("Failed to verify address to send code");
        return;
      }

      // if (last_chatbot_user_email) {
      // }

      // good
      await callApi(
        "/api/check-user",
        { email: emailState },
        (data) => {
          if (data.exists) {
            toast.warning("user already exists");
            onVerified(emailState);
            sessionStorage.removeItem("last_chatbot_user_email");
            sessionStorage.removeItem("code_sent_not_verified");
            // sessionStorage.setItem(`email_verified`, "true"); // todo
            setCodeBeenSent(false);
            setStep(undefined);
            // setTimeout(() => router.push("/chatbot"), 1000);
          } else {
            // If user does not exist, send verification code
            callApi(
              "/api/send-verification",
              { email: emailState },
              () => {
                // on success
                setStep("code");
                setCodeBeenSent(true);
                sessionStorage.setItem("code_sent_not_verified", "true");
                toast.warning(
                  "A verification code has been sent to your email!"
                );
              },
              (errorSending) => setEmailError(errorSending)
            );
          }
        },
        (errorChecking) => setEmailError(errorChecking)
      );
    },
    [setStep]
  );

  const handleGoBackToChat = () => {
    if (!isValidEmail(emailState) || !chatbot_user_email) return;

    onVerified(emailState);
    sessionStorage.setItem("chatbot_user_email", emailState);
    sessionStorage.removeItem("last_chatbot_user_email");
    toast.success(`Back to chat with email: ${emailState}`);
  };

  const verifyCode = async (e: React.FormEvent) => {
    e.preventDefault();
    setCodeError("");

    if (code.trim().length < 6) {
      setCodeError("Please enter the full verification code");
      return;
    }

    //     const response = await fetch("/api/verify-email", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify({ email, code }),
    //     });

    //     const data = await response.json();
    //     if (data.success) {
    //       // Save email to database
    //       await fetch("/api/save-user-email", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ email }),
    //       });

    await callApi(
      "/api/verify-email",
      { email: emailState, code },
      (data) => {
        console.log("verify response", data);
        onVerified(emailState);
        setCodeBeenSent(false);
        setStep(undefined);
        sessionStorage.removeItem(`code_sent_not_verified`);
      },
      (errorMsg) => setCodeError(errorMsg)
      //     setError("Network error occurred");
    );
  };

  const resendCode = async () => {
    await callApi(
      "/api/send-verification",
      { email: emailState },
      () => {
        toast.success("New verification code sent!");
        setCode("");
        setCodeBeenSent(true);
        setCodeError("");
      },
      (errorMsg) => toast.error(errorMsg || "Failed to resend code")
    );
  };

  // if (step === "email" && code_sent_not_verified !== "true") {
  if (step === "email") {
    return (
      // ${className}
      <div className={`space-y-4 w-full flex flex-col`}>
        {/* {emailProp?.includes("@") && last_chatbot_user_email && ( */}
        {isValidEmail(emailState) &&
          // last_chatbot_user_email &&
          emailState === chatbot_user_email && (
            <Button
              onClick={handleGoBackToChat}
              size="sm"
              className="flex justify-center self-center gap-1 p-1"
            >
              <IoIosArrowRoundBack className="dark:text-rose-500 w-7 h-7 size-5" />
              <span className="font-semibold">Go back to chat</span>
            </Button>
          )}

        {(code_sent_not_verified || codeBeenSent) && (
          <Button
            className="text-sm text-left flex self-start items-center p-1"
            onClick={() => {
              setStep("code");
            }}
          >
            <IoIosArrowRoundBack className="dark:text-rose-500 w-6 h-6" />
            <span className="text-xs">Go Back</span>
          </Button>
        )}

        <div className="text-center">
          <h4 className="font-semibold mb-2">Enter your email</h4>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            We'll send you a verification code to confirm your email address.
          </p>
        </div>

        <form onSubmit={handleSendEmailCode} className="space-y-3">
          <Input
            type="email"
            value={emailState}
            onChange={(e) => {
              setEmailState(e.target.value);
              setEmailError("");
            }}
            placeholder="Enter your email address"
            required
            disabled={isLoading}
          />

          {emailError && <p className="text-red-500 text-sm">{emailError}</p>}

          <Button
            type="submit"
            disabled={!emailState.trim() || isLoading}
            className="w-full"
          >
            {isLoading ? "Sending Email..." : "Continue"}
            {/* {isLoading ? "Sending..." : "Send Verification Code"} */}
          </Button>
        </form>

        {/* {!showCaptcha ? (
                  <form
                    onSubmit={handleEmailSubmit}
                    className="space-y-4 w-full max-w-sm"
                  >
                    <div>
                      <Input
                        type="email"
                        value={userEmail}
                        onChange={(e) => {
                          setUserEmail(e.target.value);
                          setEmailError("");
                        }}
                        placeholder="Enter your email address"
                        required
                        className="w-full"
                      />
                      {emailError && (
                        <p className="text-red-500 text-sm mt-1">{emailError}</p>
                      )}
                    </div>
        
                    <Button
                      type="submit"
                      disabled={!userEmail.trim()}
                      className="w-full bg-green-500 hover:bg-green-600"
                    >
                      Continue
                    </Button>
                  </form>
                ) : (
                  <div className="w-full max-w-sm">
                    <EmailCaptcha onVerified={handleCaptchaVerified} className="mb-4" />
                    <Button
                      variant="outline"
                      onClick={() => setShowCaptcha(false)}
                      className="w-full"
                    >
                      Back to Email
                    </Button>
                  </div>
                )} */}

        {/* {!showCaptcha ? (
                            <form
                              onSubmit={handleEmailSubmit}
                              className="space-y-4 w-full max-w-xs"
                            >
                              <div>
                                <input
                                  type="email"
                                  value={userEmail}
                                  onChange={(e) => {
                                    setUserEmail(e.target.value);
                                    setEmailError("");
                                  }}
                                  placeholder="Enter your email to start chatting"
                                  required
                                  className="w-full p-3 border border-gray-300 text-black rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none mb-4"
                                />
                                {emailError && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {emailError}
                                  </p>
                                )}
                              </div>
        
                              <button
                                type="submit"
                                disabled={!userEmail.trim()}
                                className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-black py-3 rounded-lg font-medium text-sm transition-colors duration-200"
                              >
                                Continue
                              </button>
                            </form>
                          ) : (
                            <div className="w-full max-w-xs">
                              <EmailCaptcha
                                onVerified={handleCaptchaVerified}
                                className="mb-4"
                              />
                              <Button
                                variant="outline"
                                onClick={() => setShowCaptcha(false)}
                                className="w-full text-sm"
                              >
                                Back to Email
                              </Button>
                            </div>
                          )} */}
      </div>
    );
  }

  return (
    <div className={`space-y-4 w-full`}>
      <div className="text-center">
        <h4 className="font-semibold mb-2">Check your email</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          We sent a 6-digit code to <strong>{emailState}</strong>
        </p>
      </div>

      <form onSubmit={verifyCode} className="space-y-3">
        {/* <Input
          type="text"
          value={code}
          onChange={(e) => {
            setCode(e.target.value.replace(/\D/g, "").slice(0, 6));
            setCodeError("");
          }}
          placeholder="Enter 6-digit code"
          maxLength={6}
          required
          disabled={isLoading}
          className="text-center text-lg tracking-widest"
        /> */}

        <div className="flex justify-center space-x-2">
          <InputOTP
            maxLength={6}
            value={code}
            onChange={(value) => setCode(value)}
            pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
          >
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              {/* </InputOTPGroup>
            <InputOTPSeparator />
            <InputOTPGroup> */}
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>

        {codeError && <p className="text-red-500 text-sm">{codeError}</p>}

        <div className="flex gap-2">
          <Button
            type="submit"
            disabled={code.length !== 6 || isLoading}
            className="flex justify-center"
            // disabled={code.length !== 6 || isLoading}
          >
            {isLoading ? "Verifying..." : "Verify Code"}
          </Button>

          <Button
            type="button"
            variant="outline"
            onClick={() => setStep("email")}
            className="flex-1"
            disabled={isLoading}
          >
            Back
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={resendCode}
            className="flex-1"
            disabled={isLoading}
          >
            Resend Code
          </Button>
        </div>
      </form>
    </div>
  );
}
